// extracted by mini-css-extract-plugin
module.exports = {"w1gk8gn6":"w1gk8gn6"};